import { Button } from "@mui/material";
import React from "react";
import "./css/Home.css";
import Footer from "./Footer.jsx";
import { useNavigate } from "react-router-dom";
import Terms from "./Terms";

function Home() {
  const [open, setopen] = React.useState(false);
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <div className="home-bg">
          <div className="home">
            <div className="home-text">
              <div>
                <h2 className="home-text-h2"> Malware Detection System </h2>
              </div>

              <div>
                <Button
                  style={{ backgroundColor: "black", color: "white" }}
                  onClick={() => {
                    navigate("/demo");
                  }}
                >
                  Book a Demo
                </Button>
              </div>
              <div
                style={{ padding: "20px", marginTop: "30px" }}
                className="button-hidden"
              >
                <Button
                  style={{ background: "black", color: "#fff" }}
                  onClick={() => {
                    navigate("/privacypolicy");
                  }}
                >
                  Privacy Policy
                </Button>
                <Button
                  style={{ background: "black", color: "#fff" }}
                  onClick={() => {
                    setopen(true);
                  }}
                >
                  Terms
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
      <Terms open={open} setopen={setopen} />
    </div>
  );
}

export default Home;
